import { combineReducers } from 'redux';
import Twilio from './twilio';
import Alert from './Alert'
import Auth from "./Auth"
import Bulk from "./Bulk"
import payment from "./payment"
import agent from './Aiagent'; // ✅ Import the agent reducer
import webhook from './aiwebhook'; // ✅ Import
import aichatbot from './aichatbot'; // ✅ Import
import podioLookup from './podioLookup';
import intentsReducer from './Intents';
import logsChatAssistantReducer from './logsChatAssistant';
import aiSettings from './aiSettings'; // ✅ ADD THIS IMPORT


const rootReducer = combineReducers({
  Twilio: Twilio,
  alert: Alert,
  auth: Auth,
  bulk: Bulk,
  payment:payment,
  agent: agent, // ✅ Add agent reducer to store
  webhook:  webhook, // ✅ Mount under 'webhook'
  aichatbot: aichatbot, // ✅ Add AI chatbot reducer
  podioLookup:podioLookup, // ✅ mount lookup slice
  intents: intentsReducer, // ✅ mount intent slice
  logsChatAssistant: logsChatAssistantReducer, // For globally active chat UI
  aiSettings: aiSettings //ai settings 

});
export default rootReducer;
